import React from 'react';

import {
  CalendarAndClockIcon,
  Card,
  Container,
  Name,
  TitleIconContainer,
  TitleSection
} from './AppointmentTypeCard.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { networkClinicCopy } from 'screens/Book/networkClinicBookingCopy';
import { useBreakpoints } from 'utilities/useBreakpoints';

interface Props {
  onClick: () => void;
}

export const PartnerClinicCard = ({ onClick }: Props) => {
  const { isDesktop } = useBreakpoints();

  return (
    <Container>
      <Card>
        <TitleSection>
          <TitleIconContainer>
            <CalendarAndClockIcon />
          </TitleIconContainer>
          <Name>{networkClinicCopy.searchOurNetwork}</Name>
        </TitleSection>
        <Button
          label={networkClinicCopy.findClinic}
          size={isDesktop ? 'md' : 'lg'}
          category="primary"
          onClick={onClick}
          fullWidth
        />
      </Card>
    </Container>
  );
};
